//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'button-dropdown',

  data () {
    return {
      isActive: false,
      inputValue: this.value,
      editableValue: null
    }
  },

  props: {
    dark: Boolean,
    editable: Boolean,
    light: {
      type: Boolean,
      default: true
    },
    options: {
      type: Array,
      default: () => []
    },
    maxHeight: {
      type: [String, Number],
      default: 200
    },
    overflow: Boolean,
    label: {
      type: String,
      default: 'Select'
    },
    segmented: Boolean,
    value: {
      required: false
    }
  },

  computed: {
    classes () {
      return {
        'btn-dropdown--editable': this.editable,
        'btn-dropdown--overflow': this.overflow || this.segmented || this.editable,
        'btn-dropdown--segmented': this.segmented,
        'btn-dropdown--light': this.light && !this.dark,
        'btn-dropdown--dark': this.dark
      }
    },

    computedItems () {
      if (this.editable) {
        return this.options
      }

      if (this.index !== -1 &&
        (this.overflow || this.segmented)
      ) {
        return this.options.filter((obj, i) => i !== this.index)
      }

      return this.options
    },

    index () {
      return this.options.findIndex(i => i === this.inputValue)
    }
  },

  mounted () {
    if (this.inputValue) {
      this.editableValue = this.inputValue.text
    } 
  },

  watch: {
    isActive () {
      if (this.editable) {
        if (!this.isActive) {
          this.$refs.input.$el.querySelector('input').blur()
        }
      }
    },

    inputValue () {
      this.$emit('input', this.inputValue)
    },

    value () {
      if (typeof this.value === 'string') {
        return (this.inputValue = { title: this.value })
      }

      this.inputValue = this.value
    }
  },

  methods: {
    toggle (active) {
      this.isActive = active
    },

    updateValue (obj) {
      if (typeof obj === 'string') {
        obj = { text: obj }
      }

      this.inputValue = obj
      this.editableValue = obj.text || obj.action
      this.isActive = false
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/buttons/ButtonDropdown.vue